import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTidakAdaDokter extends React.Component {
    render() {
        const { showModalDokter, CancelHandler, DeleteHandler2, Model, List, janjiHandler, createHandler, Model2 } = this.props

        return (
            <div>
                
                <Modal show={showModalDokter} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>CEK KETERSEDIAAN JADWAL</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Mohon maaf, Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut <br /> <br />
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={()=>{janjiHandler(Model2._id)}}>Pilih Jadwal Lain </button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}